// /app/data/vehicle-cat-shared.js

// Front and back end shared vehicle configuration file.  Contains the available vehicle catalogues for selection.
// embedded into source js, for populating selects and image paths
// each catalogue contains vehicle groups and vehicle configurations within each group.

export const vehicleCatalogues = {
   'wa-trucks': {
      index: 0,
      imgPath: '/img/wa-trucks/',
      apiUri: '/api/vehicles?catName=wa-trucks',
      entries: [
         {
            index: 0,
            name: 'Tandem Drive -Truck and Trailer',
            drive_axles: 2,
            //key: 'truck_trailers',
            imageGroupPath: 'truck-trailer/',
            filename: 'truck-trailer.json',
         },
         {
            index: 1,
            name: 'Tandem Drive - Prime Mover and Trailer',
            drive_axles: 2,
            //key: 'prime_movers',
            imageGroupPath: 'prime-mover/',
            filename: 'prime-mover.json',
         },
         {
            index: 2,
            name: 'Tri Drive - Truck and Trailer',
            drive_axles: 3,
            //key: 'tri_truck_trailers',
            imageGroupPath: 'tri-drive/',
            filename: 'tri-drive-truck-trailer.json',
         },
         {
            index: 3,
            name: 'Tri Drive - Prime Mover and Trailer',
            drive_axles: 3,
            //key: 'tri_prime_movers',
            imageGroupPath: 'tri-drive/',
            filename: 'tri-drive-prime-mover.json',
         },
         {
            index: 4,
            name: 'PBS - Tandem Drive - Prime Mover and Trailer',
            drive_axles: 2,
            //key: 'quad_axle',
            imageGroupPath: 'pbs-quad-axle/',
            filename: 'pbs-quad.json',
         },
         {
            index: 5,
            name: 'PBS - Tri Drive - Prime Mover and Trailer',
            drive_axles: 3,
            //key: 'quad_axle',
            imageGroupPath: 'pbs-quad-axle/',
            filename: 'pbs-quad-tri-drive.json',
         },
         {
            index: 6,
            name: 'AMMS - Tandem Drive -Truck and Trailer',
            drive_axles: 2,
            //key: 'amms_truck_trailers',
            imageGroupPath: 'amms-truck-trailer/',
            filename: 'amms-truck-trailer.json',
         },
         {
            index: 7,
            name: 'AMMS - Tandem Drive - Prime Mover and Trailer',
            drive_axles: 2,
            //key: 'amms_prime_movers',
            imageGroupPath: 'amms-prime/',
            filename: 'amms-prime-mover.json',
         },
         {
            index: 8,
            name: 'AMMS - Tri Drive - Truck and Trailer',
            drive_axles: 3,
            //key: 'amms_tri_truck_trailers',
            imageGroupPath: 'amms-tri-truck/',
            filename: 'amms-tri-drive-truck.json',
         },
         {
            index: 9,
            name: 'AMMS - Tri Drive - Prime Mover and Trailer',
            drive_axles: 3,
            //key: 'amms_tri_prime_movers',
            imageGroupPath: 'amms-tri-prime/',
            filename: 'amms-tri-drive-prime-mover.json',
         },
         {
            index: 10,
            name: 'AMMS PBS - Tandem Drive - Prime Mover and Trailer',
            drive_axles: 2,
            //key: 'amms_quad_axle',
            imageGroupPath: 'pbs-quad-axle/',
            filename: 'amms-pbs-quad.json',
         },
         {
            index: 11,
            name: 'AMMS PBS - Tri Drive - Prime Mover and Trailer',
            drive_axles: 3,
            //key: 'amms_quad_axle',
            imageGroupPath: 'pbs-quad-axle/',
            filename: 'amms-pbs-quad-tri-drive.json',
         },
      ],
   },
   'wa-intersection': {
      index: 2,
      imgPath: '/img/wa-rav/',
      apiUri: '/api/vehicles?catName=wa-intersection',
      entries: [
         {
            index: 0,
            name: 'General/PBS - Class 1',
            drive_axles: 2,
            //key: 'ravrat_0',
            imageGroupPath: 'common-rav23/',
            filename: 'ravrat.json',
         },
         {
            index: 1,
            name: 'Common RAV - Class 2/3',
            drive_axles: 2,
            //key: 'wa_rav_0',
            imageGroupPath: 'common-rav23/',
            filename: 'wa-rav.json',
         },
         {
            index: 2,
            name: 'Common RAV (AMMS) - Class 2/3',
            drive_axles: 2,
            //key: 'wa_rav_1',
            imageGroupPath: 'common-rav23/',
            filename: 'wa-rav-amms.json',
         },
      ],
   },
   'wa-trailer-clearance': {
      index: 0,
      imgPath: '/img/wa-rav/',
      apiUri: '/api/vehicles?catName=wa-trailer-clearance',
      entries: [
         {
            index: 0,
            name: 'Common RAV',
            drive_axles: 2,
            //key: 'wa_rav_0',
            imageGroupPath: 'common-rav23/',
            filename: 'wa-clearance-rav-combs.json',
         },
      ],
   },
};
